import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/layouts/Bullseye/bullseye.mjs';
export const Bullseye = (_a) => {
    var { children = null, className = '', component = 'div' } = _a, props = __rest(_a, ["children", "className", "component"]);
    const Component = component;
    return (_jsx(Component, Object.assign({ className: css(styles.bullseye, className) }, props, { children: children })));
};
Bullseye.displayName = 'Bullseye';
//# sourceMappingURL=Bullseye.js.map